// extracted by mini-css-extract-plugin
module.exports = {"root":"mLeU7-vF","disableScrolling":"PQjP6F8N"};